exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".labels-top {\r\n    margin-top: 20px;\r\n    margin-left: -15px;\r\n    word-break: break-all;\r\n    width: 1200px;\r\n}\r\n\r\n.labels-right {\r\n    margin-right: 50px;\r\n}\r\n\r\n.spine-label {\r\n    width: 245px;\r\n    height: 67px;\r\n    /*margin-right: 16px;\r\n    margin-left: 16px;\r\n    margin-bottom: 5px;*/\r\n    text-align: center;\r\n    display: inline-block;\r\n}\r\n\r\n.call-number {\r\n    font-size: 13px;\r\n    font-weight: bold;\r\n    white-space: pre-line;\r\n    line-height: 1;\r\n    position: absolute;\r\n    padding-top: 15px;\r\n    margin-left: -25px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/print-spine-label/print-spine-label.component.css
// module id = ../../../../../src/app/print-spine-label/print-spine-label.component.css
// module chunks = 1